<div class="container-fluid full-height" *ngIf="userProfile">

    <div *ngIf="!isMobile" class="main-menu">
        <div class="menu-left">
            
        </div>
        <div class="menu-right">
            <button mat-button *ngxPermissionsOnly="['SuperAdmin', 'Admin', 'Assistant']" [routerLink]="['/settings']">{{ 'MENU.ADMIN' | translate }}</button>
            <button mat-button [routerLink]="['/']">{{ 'MENU.ASSESSMENTS' | translate }}</button>

            <button mat-button [routerLink]="['/company-selector']">{{ company?.name ?? ('MENU.NO_COMPANY' | translate) }}</button>
    
            <button mat-button [matMenuTriggerFor]="userMenu" [title]="role" class="usermenu">
                <mat-icon>arrow_drop_down</mat-icon> <mat-icon>account_circle</mat-icon><span>{{ userProfile | userDisplayName }}</span>
            </button>
            <mat-menu #userMenu="matMenu">
                <button mat-menu-item [routerLink]="['/employee']">{{ 'MENU.PROFILE' | translate }}</button>
                <button mat-menu-item [routerLink]="['/test-page']" *ngIf="canSeeTestPage">Test page</button>
                <mat-divider *ngIf="!(appState.iframeLoginMode.obs$ | async)"></mat-divider>
                <button mat-menu-item (click)="logOut()" *ngIf="!(appState.iframeLoginMode.obs$ | async)">{{ 'MENU.LOGOUT' | translate }}</button>
            </mat-menu>
        </div>
    </div>

    <div *ngIf="isMobile" class="mobile-menu">
        
        <ul class="id-panel">
            <li>
                <div class="flex-h align-items-center justify-content-center">
                    <a [routerLink]="['/employee']" (click)="mobileMenuClick()">{{ userProfile | userDisplayName }}</a> <mat-icon>account_circle</mat-icon>
                </div>
                <span>{{ role }}</span>
            </li>
            <li class="flex-h align-items-center justify-content-center">
                <mat-icon>domain</mat-icon> <a [routerLink]="['/company-selector']" (click)="mobileMenuClick()">{{ company?.name ?? ('MENU.NO_COMPANY' | translate) }}</a>
            </li>
        </ul>
        
        <div class="menu-content">
            <mat-card class="items-card">
                <mat-card-content>
    
                    <ul class="items-panel">
                        <li *ngxPermissionsOnly="['SuperAdmin', 'Admin', 'Assistant']">
                            <a [routerLink]="['/settings']" (click)="mobileMenuClick()">{{ 'MENU.ADMIN' | translate }}</a>
                        </li>
                        <li>
                            <a [routerLink]="['/']" (click)="mobileMenuClick()">{{ 'MENU.ASSESSMENTS' | translate }}</a>
                        </li>
                        <li *ngIf="canSeeTestPage">
                            <a [routerLink]="['/test-page']" (click)="mobileMenuClick()">Test page</a>
                        </li>
                        <li *ngIf="!(appState.iframeLoginMode.obs$ | async)">
                            <a href="#" (click)="logOut()">{{ 'MENU.LOGOUT' | translate }}</a>
                        </li>
                    </ul>
                </mat-card-content>
            </mat-card>
        </div>

    </div>
</div>
